import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgBuilding(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5775_5613)">
        <g clipPath="url(#clip1_5775_5613)">
          <path
            d="M0 16V0H8V3.42857H16V16H0ZM1.5 14.2857H3V12.5714H1.5V14.2857ZM1.5 10.6667H3V8.95238H1.5V10.6667ZM1.5 7.04762H3V5.33333H1.5V7.04762ZM1.5 3.42857H3V1.71429H1.5V3.42857ZM5 14.2857H6.5V12.5714H5V14.2857ZM5 10.6667H6.5V8.95238H5V10.6667ZM5 7.04762H6.5V5.33333H5V7.04762ZM5 3.42857H6.5V1.71429H5V3.42857ZM8 14.2857H14.5V5.14286H8V7.04762H9.5V8.7619H8V10.6667H9.5V12.381H8V14.2857ZM11.5 8.7619V7.04762H13V8.7619H11.5ZM11.5 12.381V10.6667H13V12.381H11.5Z"
            fill="#666666"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5775_5613">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(0 -1 1 0 0 16)"
          />
        </clipPath>
        <clipPath id="clip1_5775_5613">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
